<template>
    <v-dialog-old id="settings-token-sber" @hidden="cancel" :onCloseEsc="closeModal" ref="settingsTokenDialog" class="glue" :special-styles="{ width: '650px' }">
        <v-dialog-old @hidden="closeModal" :onCloseEsc="closeModal" ref="okDialog" class="glue">
            <strong>Токен сохранен!</strong>
            <footer><button @click="closeModal" class="green btn-norm" type="submit">OK</button></footer>
        </v-dialog-old>
        <fieldset>
            <legend>Настройка токена авторизации Сбер</legend>
            <form>
                <div class="status_wrapper">
                    <strong>Статус:</strong>
                    <small v-if="M.status === 'success'" class="label pull-right bg-green" >
                        Токен активен
                    </small>
                    <small v-if="M.status === 'absent'" class="label pull-right bg-red" >
                        Интеграция остановлена
                    </small>
                    <small v-if="M.status === 'canceled'" class="label pull-right bg-yellow" >
                        Токен просрочен
                    </small>
                </div>

                <div v-if="M.authUrl">
                    <a :href="`${M.authUrl}`">Перейти в сбер для авторизации</a>
                </div>

                <div class="actions">
                    <button @click.prevent="goToSberAuthorization" v-if="M.status !== 'success'">Подключить</button>
                    <button @click.prevent="disableTokens" class="red" v-if="M.status !== 'absent'">Отключить</button>
                </div>
            </form>
        </fieldset>
    </v-dialog-old>
</template>

<script>
export default {
    data: () => ({
        M: {
            authUrl: '',
            status: '',
            lastUpdated: ''
        },
        ok: null,
        processing: false,
        error: null,
    }),
    methods: {
        async show() {
            await this.checkSbiTokensStatus()
            this.$refs.settingsTokenDialog.show()
        },
        cancel() {
            this.M.authUrl = ''
            this.M.status = ''
            this.M.lastUpdated = ''
            this.ok = null
            this.error = null
        },
        closeModal() {
            this.cancel()
            this.$refs.settingsTokenDialog.hide()
        },
        okModal() {
            this.$refs.okDialog.show()
        },
        async goToSberAuthorization() {
            this.error = null;
            this.processing = true;
            await this.axios.post('/admin/settings/tools/goToSberAuthorization').then((response) => {
                this.M.authUrl = response.data.authUrl
            })
        },
        async disableTokens() {
            this.error = null;
            this.processing = true;
            await this.axios.post('/admin/settings/tools/disableTokens').then((response) => {
                this.checkSbiTokensStatus()
            })
        },
        async checkSbiTokensStatus(){
            this.error = null;
            this.processing = true;
            await this.axios.post('/admin/settings/tools/checkSbiTokensStatus').then((response) => {

                this.M.status = response.data.tokens_status
                this.M.lastUpdated = response.data.last_updated
            })
        }
    },
}
</script>
<style lang="scss" scoped>
.mt-10 {
    margin-top: 10px;
}
.center {
    text-align: center;
}
.sc-pad-lr-20 {
    padding-left: 20px;
    padding-right: 20px;
}

#settings-token-sber{
    form{
        display: flex;
        flex-direction: column;
        gap: 16px;
        margin-top: 16px;
    }
    .status_wrapper{
        display: flex;
        flex-direction: row;
        gap:8px;
    }
    .actions{
        margin-top: 11px;

        display: flex;
        gap: 8px;
        justify-content: center;
    }
}

</style>
